import React from "react";
import { FaArrowLeft, FaBars } from "react-icons/fa";
import * as SCREENS from "../constants/screens";
import { saveName } from "../api"
import { useBlueBody } from "../hooks/useBlueBody";

export default function Name({ dataManager, sidebarManager }) {
  const { data, setData } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    setData({ ...data, screen: SCREENS.ADMINISTRATORS });
  }

  async function nextScreen() {
    const screen = data.redirected ? SCREENS.FINALITY : 
    data.administrator === "Servopa" && data.servopa_mode === 1 ? SCREENS.SERVOPA_MPAR
      : SCREENS.TYPE_INTO;
    if (window !== undefined) localStorage.setItem("name", data.name);
    let doc = await saveName(data.name);
    setData({ ...data, screen: screen, docRef: doc.id });
    console.log(doc.id)
  }

  function setName(name) {
    setData({ ...data, name: name });
  }

  const isNameValid = () => {
    return data.name.length >= 2 && data.name.length <= 26;
  };

  return (
    <section className="administrators-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            {data.redirected ? (
              <div style={{ width: 20, height: 20 }} />
            ) : (
              <FaArrowLeft
                role="button"
                className="icon-bar"
                onClick={prevScreen}
              />
            )}
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "40%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Como podemos te chamar?</h1>
        <h2>Digite seu nome no campo abaixo.</h2>
      </div>
      <div className="bottom-panel container">
        <input
          className="form-control mb-2"
          type="text"
          value={data.name}
          placeholder="Nome"
          onChange={(e) => setName(e.target.value)}
        />
        {!isNameValid() ? (
          <div className="alert alert-primary" role="alert">
            O nome deve ter entre 2 e 26 letras.
          </div>
        ) : null}
        <button
          className="btn btn-secondary mt-auto"
          disabled={!isNameValid()}
          onClick={nextScreen}
        >
          Continuar
        </button>
      </div>
    </section>
  );
}
